export default "__VITE_PUBLIC_ASSET__3af6ae2d__"